import { toast } from 'react-toastify';
import ReactDOM from 'react-dom/client';
import axios from "axios";
import React, { useState, useEffect } from "react";
import i18n from 'i18next';
import Login from './Login';
import ObjectView from './ObjectsView';
import { InputWithLabel, Button, Textarea, Input, CheckBox } from './Controls/Controls';

//#region Common
let loadingOverlayElement = null;
let rootInstance = null;

export function Translate(key) 
{
    return i18n.t(key);
}

export function openLoadingOverlay() 
{
    if (!loadingOverlayElement) 
    {
        loadingOverlayElement = document.createElement('div');
        loadingOverlayElement.className = 'loading-overlay';
        const spinnerElement = document.createElement('div');
        spinnerElement.className = 'loading-spinner';
        const textElement = document.createElement('div');
        textElement.className = 'loading-text';
        textElement.textContent = Translate("Loading") + "...";
        loadingOverlayElement.appendChild(spinnerElement);
        loadingOverlayElement.appendChild(textElement);
        document.body.appendChild(loadingOverlayElement);
    }
}

export function closeLoadingOverlay() 
{
    if (loadingOverlayElement) 
    {
        document.body.removeChild(loadingOverlayElement);
        loadingOverlayElement = null;
    }
}

export function Host()
{
    return "/services/PortalFunctions.asmx/"; //https://ahit-v2.ase-edv.eu/services/PortalFunctions.asmx/"; //  "https://localhost:44394/services/PortalFunctions.asmx/"  "/services/PortalFunctions.asmx/";
    //return "https://localhost:44394/services/PortalFunctions.asmx/";
}

export function FileHost()
{
    return "/services/FileServices.ashx/"; //https://ahit-v2.ase-edv.eu/services/PortalFunctions.asmx/"; //  "https://localhost:44394/services/PortalFunctions.asmx/"  "/services/PortalFunctions.asmx/";
    //return "https://localhost:44394/services/FileServices.ashx";
}

//#endregion Common

//-------------------------------------------------------------------------------------------------------------------

//#region Login Functions

export async function CheckLoggedIn() 
{
    try 
    {
        if (localStorage.getItem('successLogin') === 'true') { return true }

        const data = {
            sessionID: localStorage.getItem('sessionID')
        };
  
        const response = await axios.post(Host() + 'SessionValid', data);
  
        if (response.status === 200) 
        {
            if (response.data.d != null && response.data.d) 
            {
                // const xmlDoc = new DOMParser().parseFromString(response.data, "text/xml");
                // const isLoggedIn = xmlDoc.getElementsByTagName("boolean")[0].textContent === "true";
                return true;
            }
        }
  
        return false;
    } 
    catch (error) 
    {
        Toastmessage(error, 3);
        return false;
    }
}

export function DoLogin(username, password, recaptcha) 
{
    recaptcha = "abc";
    if (!username || !password || !recaptcha) 
    {
        if (!username ) 
        {
            Toastmessage("Das Feld 'Benutzername' muss befüllt sein.", 3);
            AddClasstoElement("login_username", "errorBorder");
        }
        else
        {
            RemoveClassFromElement("login_username", "errorBorder");
        }
        
        if (!password)
        {
            Toastmessage("Das Feld 'Passwort' muss befüllt sein.", 3);
            AddClasstoElement("login_password", "errorBorder");
        }
        else
        {
            RemoveClassFromElement("login_password", "errorBorder");
        }

        if (!recaptcha)
        {
            Toastmessage("Das 'ReCaptcha' muss bestätigt werden.", 3);
        }
    }
    else
    {
        openLoadingOverlay();

        RemoveClassFromElement("login_username", "errorBorder");
        RemoveClassFromElement("login_password", "errorBorder");

        const url = Host() + "Login";
        const data = {
            "username" : username,
            "password" : password,
            "recaptcha" : recaptcha
        };

        axios.post(url, data)
        .then(response => 
        {
            if (response.status === 200) 
            {
                if (response.data.d !== "" && response.data.d.split("|").length > 1) 
                {
                    const getMsg = response.data.d.split("|");

                    if (getMsg[0] === "Success") 
                    {
                        localStorage.setItem('sessionID', getMsg[2]);
                        localStorage.setItem('successLogin', 'true');

                        if (!rootInstance) 
                        {
                            rootInstance = ReactDOM.createRoot(document.getElementById('root'));
                        }

                        rootInstance.render(<ObjectView />);
                    }
                    else
                    {
                        Toastmessage(getMsg[1], 3);
                        throw new Error("");
                    }
                }
                else
                {
                    throw new Error("");
                }
            }
        })
        .catch(({error}) => 
        {
            //window.grecaptcha.reset();
            localStorage.setItem('successLogin', 'false');
            if(error !== null && error !== "") Toastmessage(error, 3);
        })
        .finally(() => 
        {
            closeLoadingOverlay();
        });
    }
}

export function Logout() 
{
    if (!rootInstance) 
    {
        rootInstance = ReactDOM.createRoot(document.getElementById('root'));
    }

    localStorage.clear();
    rootInstance.render(<Login />);
};

export function ShowPWD(id) {
    var x = document.getElementById(id);
    x.type = (x.type === "password" ? x.type = "text" : x.type = "password");
}

//#endregion Login Functions

//-------------------------------------------------------------------------------------------------------------------

//#region Toastmessages
export function Toastmessage(message, type = 0)
{
    if (type === 1) {
        return toast.success(message, {
                    position: "top-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
    }
    else if (type === 2)
    {
        return toast.warn(message, 
                {
                    position: "top-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
    }
    else if (type === 3)
    {
        return toast.error(message, 
                {
                    position: "top-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
    }
    else
    {
        return toast.info(message, 
                {
                    position: "top-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
    }
}

//#endregion Toastmessages

//-------------------------------------------------------------------------------------------------------------------

//#region Common Functions


export function AddClasstoElement(id, classname)
{
    let elem = document.getElementById(id);

    if (!elem.classList.contains(classname)) {
        elem.classList.add(classname);
    }
}

export function RemoveClassFromElement(id, classname)
{
    let elem = document.getElementById(id);

    if (elem.classList.contains(classname)) {
        elem.classList.remove(classname);
    }
}

export function ArrayBufferToBase64(buffer) 
{
    var binary = '';
    var bytes = [].slice.call(new Uint8Array(buffer));
    bytes.forEach((b) => binary += String.fromCharCode(b));
    return window.btoa(binary);
}

export function RemoveSpecialCharactersFromString(value)
{
    const str = value.toString().replace(/[^a-zA-Z ]/g, "");
    return str;
}

export function sleep(ms = 1000)
{
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export function GetData(url, data = {})
{
    return new Promise((resolve, reject) => {    
        axios
            .post(url, data)
            .then((res) => {
                if (res.status === 200) 
                {
                    if (res.data.d !== null) 
                    {
                        resolve(res.data.d);
                    } 
                    else 
                    {
                        reject(new Error(''));
                    }
                }
            })
            .catch(({ error }) => 
            {
                if (error !== null && error !== '') 
                {
                    console.log(error);
                    reject(error);
                }
            });
    });
}

//#endregion Common Functions

//-------------------------------------------------------------------------------------------------------------------

//#region orderView Functions

export function DownloadFile(file) 
{
    const url = FileHost();
    const params = {
        SessionID: localStorage.getItem('sessionID'),
        File: file.URL,
        Filename: file.Name
    };

    openLoadingOverlay();

    axios.get(url, { params, responseType: 'blob' })
    .then(res => 
    {
        if (res.status === 200) 
        {
            if (res.data !== null) 
            {
                const blob = new Blob([res.data], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', file.Name);
                document.body.appendChild(link);
                link.click();
            
                window.URL.revokeObjectURL(url);
                closeLoadingOverlay();
            } 
            else 
            {
                throw new Error("No data returned.");
            }
        }
    })
    .catch(error => {
        closeLoadingOverlay();
        if(error !== null && error !== "") Toastmessage("Es ist ein Fehler aufgetreten. (Code: 1002)", 3);
        console.error('Error downloading file:', error);
    });
}

export function OpenFile(file) 
{
    const url = FileHost();
    const params = {
        SessionID: localStorage.getItem('sessionID'),
        File: file.URL,
        Filename: file.Name
    };

    const fileName = file.Name.toLowerCase(); 
    const fileExtension = fileName.slice((fileName.lastIndexOf(".") - 1 >>> 0) + 2); 

    if(!isImage(fileExtension) && !isPDF(fileExtension))
    {
        Toastmessage("Nur Bilder und PDFs können geöffnet werden.", 2);
        return;
    }

    openLoadingOverlay();

    axios.get(url, { params, responseType: 'blob' })
    .then(res => {
        if (res.status === 200)
        {
            if (res.data !== null)
            {
                if (isImage(fileExtension)) 
                {
                    const blob = new Blob([res.data], { type: 'image/' + fileExtension });
                    const fileURL = window.URL.createObjectURL(blob);
                    window.open(fileURL, '_blank');
                } 
                else if (isPDF(fileExtension)) 
                {
                    const blob = new Blob([res.data], { type: 'application/pdf' });
                    const fileURL = window.URL.createObjectURL(blob);
                    window.open(fileURL, '_blank');
                }
                // else 
                // {
                //     const blob = new Blob([res.data], { type: 'application/octet-stream' });
                //     const fileURL = window.URL.createObjectURL(blob);
                //     window.open(fileURL, '_blank');
                // }
                // else if (isWord(fileExtension)) 
                // { 
                //     const blob = new Blob([res.data], { type: 'application/msword' });
                //     const fileURL = window.URL.createObjectURL(blob);
                //     window.open(fileURL, '_blank');
                // }
                // else if (isExcel(fileExtension)) 
                // { 
                //     const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
                //     const fileURL = window.URL.createObjectURL(blob);
                //     window.open(fileURL, '_blank');
                // }


                closeLoadingOverlay();
            } 
            else 
            {
                throw new Error("No data returned.");
            }
        }
    })
    .catch(error => 
    {
        closeLoadingOverlay();
        if (error !== null && error !== "") Toastmessage("Es ist ein Fehler aufgetreten. (Code: 1002)", 3);
        console.error('Error opening file:', error);
    });
}

function isWord(extension) 
{
    const wordExtensions = ['doc', 'docx'];

    return wordExtensions.includes(extension);
}

function isExcel(extension) 
{
    const excelExtensions = ['xls', 'xlsx'];

    return excelExtensions.includes(extension);
}

function isImage(extension) 
{
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];

    return imageExtensions.includes(extension);
}

function isPDF(extension) 
{
    const pdfExtensions = ['pdf'];

    return pdfExtensions.includes(extension);
}

export function GetObjectsFiles(explorer = "", ID = "")
{
    return new Promise((resolve, reject) => {
        const url = Host() + "GetObjectsFiles";
        const data = {
            sessionID: localStorage.getItem('sessionID'),
            explorer: explorer,
            ID: ID
        };
        
        axios.post(url, data)
        .then(res => 
        {
            if (res.status === 200) 
            {
                if (res.data.d !== null) 
                {
                    resolve(res.data.d);
                }
                else
                {
                    Logout();
                    reject(new Error("No data returned."));
                }
            }
        })
        .catch(error => 
        {
            if(error !== null && error !== "") Toastmessage("Es ist ein Fehler aufgetreten. (Code: 1001)", 3);
        });
    });
}

export function GetCustomerOrders()
{
    const [responseData, setResponseData] = useState(null);

    useEffect(() => {
        const url = Host() + "GetCustomerOrders";
        const data = {
            sessionID: localStorage.getItem('sessionID')
        };
        
        const fetchData = async () => 
        {
            await axios.post(url, data)
            .then(res => 
            {
                if (res.status === 200) 
                {
                    if (res.data.d !== null) 
                    {
                        setResponseData(res.data.d);
                    }
                    else
                    {
                        throw new Error("");
                    }
                }
            })
            .catch(({error}) => 
            {
                if(error !== null && error !== "") Toastmessage("Es ist ein Fehler aufgetreten. (Code: 1002)", 3);
            });
        };

        fetchData();
    }, []);

    if (responseData !== null && responseData !== "") 
    {
        return CreateDynTableData(responseData);
    } 
    else 
    {
        return null;    
    }
}

export function GetCustomerBookings() 
{
    return new Promise((resolve, reject) => {
        const url = Host() + 'GetCustomerBookings';
        const orderID = localStorage.getItem('Current_Order') || '';
        let MonthTable_FromDate = localStorage.getItem('MonthTable_FromDate') || '';
        let MonthTable_ToDate = localStorage.getItem('MonthTable_ToDate') || '';
        let WeekTable_FromDate = localStorage.getItem('WeekTable_FromDate') || '';
        let WeekTable_ToDate = localStorage.getItem('WeekTable_ToDate') || '';
        let _fromDate = MonthTable_FromDate || WeekTable_FromDate || '';
        let _toDate = MonthTable_ToDate || WeekTable_ToDate || '';
    
        const data = {
            sessionID: localStorage.getItem('sessionID'),
            order: orderID,
            fromDate: _fromDate,
            toDate: _toDate,
        };
    
        if (orderID !== '' && _fromDate !== '' && _toDate !== '') 
        {
            axios
                .post(url, data)
                .then((res) => {
                    if (res.status === 200) 
                    {
                        if (res.data.d !== null) 
                        {
                            resolve(CreateDynTableData(res.data.d));
                        } 
                        else 
                        {
                            reject(new Error(''));
                        }
                    }
                })
                .catch(({ error }) => 
                {
                    if (error !== null && error !== '') 
                    {
                        console.log(error & " - Code: 1004");
                        Toastmessage('Es ist ein Fehler aufgetreten. (Code: 1004)', 3);
                        reject(error);
                    }
                });
        } 
        else 
        {
            resolve(null);
        }
    });
}

export function CreateNewBooking(getDate, _ORSP, _ORSV)
{
    openLoadingOverlay();

    const url = Host() + 'GetBookingPositions';
    const data = {
        sessionID: localStorage.getItem('sessionID'),
        orderID: localStorage.getItem("Current_Order"),
        fromDate: getDate,
        ORSP: _ORSP,
        ORSV: _ORSV
    };

    GetData(url, data)
        .then((posData) => {
            const bookingRecordElement = React.createElement(BookingRecord, posData);
            const bookingDiv = document.createElement('div');
            bookingDiv.id = 'bookingOverlay';
            bookingDiv.className = "loading-overlay";
            const rootChild = document.body.appendChild(bookingDiv);
            ReactDOM.createRoot(rootChild).render(bookingRecordElement);
        })
        .catch((error) => {
            console.log(error + " (Code: 1008)");
        })
        .finally(() => {
            closeLoadingOverlay();
        });
}

export function OpenBookingRecord(_bookingID) 
{
    openLoadingOverlay();
    const url = Host() + 'GetBookingData';
    const data = {
        sessionID: localStorage.getItem('sessionID'),
        bookingID: _bookingID
    };

    GetData(url, data)
        .then((d) => {
            const bookingRecordElement = React.createElement(BookingRecord, d);
            const bookingDiv = document.createElement('div');
            bookingDiv.id = 'bookingOverlay';
            bookingDiv.className = "loading-overlay";
            const rootChild = document.body.appendChild(bookingDiv);
            ReactDOM.createRoot(rootChild).render(bookingRecordElement);
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            closeLoadingOverlay();
        });
}

export function BookingRecord(data) 
{ 
    const handleSubmit = () => {
        const oBKG = {BKG_ID: document.getElementById("BKG_ID").value,
                     BKG_Name: document.getElementById("BKG_Name").value,
                     BKG_ArrivalDate: document.getElementById("BKG_ArrivalDate").value,
                     BKG_DepartureDate: document.getElementById("BKG_DepartureDate").value,
                     BKG_QuantityAdults: document.getElementById("BKG_QuantityAdults").value,
                     BKG_QuantityChildren: document.getElementById("BKG_QuantityChildren").value,
                     BKG_QuantityToddler: document.getElementById("BKG_QuantityToddler").value,
                     BKG_QuantityGuests: document.getElementById("BKG_QuantityGuests").value,
                     BKG_Notes: document.getElementById("BKG_Notes").value,
                     BKG_ORSV: document.getElementById("BKG_ORSV").value,
                     BKG_ORSP: document.getElementById("BKG_ORSP").value,
                     BKG_ORD: localStorage.getItem("Current_Order"),
                     Positions: getPositionsData()};
                     


        SaveBookingData(oBKG);
    };

    const getPositionsData = () => {
        const positions = [];
        const positionRows = document.querySelectorAll(".table-orderBody.bookingRecord tr");
    
        positionRows.forEach((row, index) => {
            if (row.id != null) 
            {
                const position = {
                    Takeover: row.querySelector(`#pos_Takeover-${index}`).checked,
                    Name: row.querySelector(`#pos_Name-${index}`).value,
                    _Date: row.querySelector(`#pos_Date-${index}`).value,
                    DateFixed: row.querySelector(`#pos_DateFixed-${index}`).checked,
                    Quantity: row.querySelector(`#pos_Quantity-${index}`).value,
                    Text1: row.querySelector(`#pos_Text1-${index}`).value,
                    Description: row.querySelector(`#pos_Description-${index}`).value,
                    Execution: row.querySelector(`#pos_Execution-${index}`).value,
                    QuantityDef: row.querySelector(`#pos_QuantityDef-${index}`).value,
                    Quantity: row.querySelector(`#pos_Quantity-${index}`).value,
                    Unit: row.querySelector(`#pos_Unit-${index}`).value,
                    Deduction: row.querySelector(`#pos_Deduction-${index}`).value,
                    PricePerUnit: row.querySelector(`#pos_PricePerUnit-${index}`).value,
                    BillingRecipient: row.querySelector(`#pos_BillingRecipient-${index}`).value,
                    ServID: row.querySelector(`#pos_ServID-${index}`).value
                };

                positions.push(position);
            }
        });
    
        return positions;
    };

    const handleClose = () => {
        document.body.removeChild(document.getElementById("bookingOverlay"));
    };

    const calcGuests = () => {
        let adults = parseInt(document.getElementById("BKG_QuantityAdults").value);
        let children = parseInt(document.getElementById("BKG_QuantityChildren").value);
        let toddler = parseInt(document.getElementById("BKG_QuantityToddler").value);
        document.getElementById("BKG_QuantityGuests").value = children + adults + toddler;
    }

    const handleArrivalDateChange = (event) => {
        const newDate = event.target.value;
    
        const elementsToUpdate = document.querySelectorAll('[id^="pos_Text1-"]');
        elementsToUpdate.forEach((element) => {
            if (element.defaultValue.trim() === 'A') 
            {
                const index = element.id.split('-')[1];
                const dateInput = document.querySelector(`#pos_Date-${index}`);
                
                if (dateInput) 
                {
                    dateInput.value = newDate;
                }
            }
        });
    };

    const handleDepartureDateChange = (event) => {
        const newDate = event.target.value;
    
        const elementsToUpdate = document.querySelectorAll('[id^="pos_Text1-"]');
        elementsToUpdate.forEach((element) => {
            if (element.defaultValue.trim() === 'D') 
            {
                const index = element.id.split('-')[1];
                const dateInput = document.querySelector(`#pos_Date-${index}`);
                
                if (dateInput) 
                {
                    dateInput.value = newDate;
                }
            }
        });
    };

    return (
        <div className="overlay open">
            <div className="overlay-content">
                <span className="close-btn" onClick={handleClose}>&times;</span>
                <h2>{data.BKG_ORSV_Name}</h2>
                <Input inputID='BKG_ID' inputClassName='d-none' inputType='text' inputValue={data.BKG_ID} />
                <Input inputID='BKG_ORSV' inputClassName='d-none' inputType='text' inputValue={data.BKG_ORSV} />
                <Input inputID='BKG_ORSP' inputClassName='d-none' inputType='text' inputValue={data.BKG_ORSP} />
                
                <InputWithLabel inputID='BKG_Name' labelStyle={{marginRight: "25px"}} inputStyle={{width: "410px"}} inputClassName={"input-field"} inputType='text' inputValue={data.BKG_Name} labelText={Translate("Name")} />
                <div className='row'>
                    <div className='col-6 col-md-4'>
                        <InputWithLabel inputID='BKG_ArrivalDate' inputClassName={"input-field"} inputType='date' inputValue={data.BKG_ArrivalDate} labelText={Translate("Arrival date")} inputOptionalParams={{ onChange: handleArrivalDateChange }} />
                    </div>
                    <div className='col-6 col-md-4'>
                        <InputWithLabel inputID='BKG_DepartureDate' inputClassName={"input-field"} inputType='date' inputValue={data.BKG_DepartureDate} labelText={Translate("Departure date")} inputOptionalParams={{ onChange: handleDepartureDateChange }} />
                    </div>
                </div>
               
                <div className='row'>
                    <div className='col-6 col-md-4'>
                        <InputWithLabel inputID='BKG_QuantityAdults' inputStyle={{width: "65px"}} inputClassName={"input-field"} inputType='number' inputValue={data.BKG_QuantityAdults} labelText={Translate("Quantity adults")} inputOptionalParams={ {onChange: () => calcGuests()} } />
                    </div>
                    <div className='col-6 col-md-4'>
                        <InputWithLabel inputID='BKG_QuantityChildren'  inputStyle={{width: "65px"}} inputClassName={"input-field"} inputType='number' inputValue={data.BKG_QuantityChildren} labelText={Translate("Quantity children")} inputOptionalParams={ {onChange: () => calcGuests()} } />
                    </div>
                </div>

                <div className='row'>
                    <div className='col-6 col-md-4'>
                        <InputWithLabel inputID='BKG_QuantityToddler' labelStyle={{marginRight: "18px"}} inputStyle={{width: "65px"}} inputClassName={"input-field"} inputType='number' inputValue={data.BKG_QuantityToddler} labelText={Translate("Quantity toddler")} inputOptionalParams={ {onChange: () => calcGuests()} } />
                    </div>
                    <div className='col-6 col-md-4'>
                        <InputWithLabel inputID='BKG_QuantityGuests' labelStyle={{marginRight: "21px"}} inputStyle={{width: "65px"}} inputClassName={"input-field"} inputType='number' inputValue={data.BKG_QuantityGuests} labelText={Translate("Quantity guests")} inputOptionalParams={{disabled: "disabled"}} />
                    </div>
                </div>

                <Textarea inputID='BKG_Notes' labelStyle={{marginRight: "25px"}} inputStyle={{width: "100%"}} inputClassName={"input-field"} inputValue={data.BKG_Notes} labelText={Translate("Notes")} />
                
                <BookingRecordTable data={data.Positions} />
                <br />
                <div align="center">
                    <Button btnID='saveBooking' btnText={Translate("Save")} inputOptionalParams={{ "onClick": handleSubmit }} />
                </div>
            </div>
        </div>
    );
}

export function SaveBookingData(oBKG_)
{
    let errorText = "";

    const validateBookingData = () => {
        const positions = oBKG_.Positions;
        let hasError = false;

        if (oBKG_.BKG_DepartureDate < oBKG_.BKG_ArrivalDate) 
        {
            const departureInput = document.getElementById("BKG_DepartureDate");
            departureInput.classList.add('error-border');

            hasError = true;
            errorText += "Das Abreisedatum kann nicht kleiner als das Anreisedatum sein.\n";
        }

        for (let index = 0; index < positions.length; index++) 
        {
            const position = positions[index];

            if (position.BKG_Takeover && (!position.BKG_Date || position.BKG_Date.trim() === "")) 
            {
                
                const dateInput = document.getElementById(`pos_Date-${index}`);

                if (dateInput) 
                {
                    dateInput.classList.add('error-border');
                }

                hasError = true;
                errorText += "Bei einer Übernahme muss ein Datum angegeben werden.\n";
            }
            else
            {
                const dateInput = document.getElementById(`pos_Date-${index}`);
                dateInput.classList.remove('error-border');
            }
        }

        return hasError;
    };

    openLoadingOverlay();

    if (validateBookingData()) 
    {
        closeLoadingOverlay();
        Toastmessage(errorText, 3);
        return;
    }

    const url = Host() + 'SaveBookingData';
    const data = {
        sessionID: localStorage.getItem('sessionID'),
        oBKG: JSON.stringify(oBKG_)
    };

    GetData(url, data)
        .then((d) => {
            if (d.includes("Erfolgreich gespeichert")) 
            {
                Toastmessage(d, 1);
                document.body.removeChild(document.getElementById("bookingOverlay"));
            }
            else
            {
                closeLoadingOverlay();
            }
        })
        .catch((error) => {
            Toastmessage(error, 3);
            console.error(error);
        })
        .finally(() => {
            closeLoadingOverlay();
            document.getElementById("refreshTable").click();
        });
}

export function BookingRecordTable(d)
{
    const [units, setUnits] = useState([]);

    useEffect(() => {
        const url = Host() + 'GetConstantsData';
        const data = {
            sessionID: localStorage.getItem('sessionID'),
            Name: "Units"
        };
    
        GetData(url, data)
            .then((d) => {
                setUnits(JSON.parse(d));
            })
            .catch((error) => {
                console.log(error + " (Code: 1007)");
            });
    }, []);

    const SelectOptions = (defValue) => {
        return units.map((option, index) => (
            <option key={index} value={option.OptionKey} selected={defValue === option.OptionKey ? "true" : "false"}>
                {option.OptionText}
            </option>
        ));
    };

    const RenderPositions = () => {
        if (!d.data || d.data.length === 0) 
        {
            return <tr><td colSpan="6">Keine Positionen vorhanden</td></tr>;
        }

        const changeDateFormat = (inputDate) => {
            const parts = inputDate.split('.');
            const day = parts[0];
            const month = parts[1];
            const year = parts[2];

            return `${year}-${month}-${day}`;
        }

        return d.data.map((position, index) => (
            <tr key={index.toString()} id={'tr_' + index.toString()}>
                <td>
                    <CheckBox chkID={"pos_Takeover-" + index.toString()} chkType={"checkbox"} chkIndicatorStyle={{position: "relative"}} chkValue={position.TakeOver} chkStyle={{marginBottom: "0px", paddingTop: "0px"}} />
                </td>
                <td>
                    <Input inputID={"pos_Name-" + index.toString()} inputType={"text"} inputValue={position.Name} inputStyle={{ border: "none", width: "100%"}} />
                </td>
                <td>
                    <Input inputID={"pos_Text1-" + index.toString()} inputType={"text"} inputValue={position.Text1} inputClassName={"d-none"} />
                    <Input inputID={"pos_Description-" + index.toString()} inputType={"text"} inputValue={position.Description} inputClassName={"d-none"} />
                    <Input inputID={"pos_Execution-" + index.toString()} inputType={"text"} inputValue={position.Execution} inputClassName={"d-none"} />
                    <Input inputID={"pos_QuantityDef-" + index.toString()} inputType={"text"} inputValue={position.QuantityDef} inputClassName={"d-none"} />
                    <Input inputID={"pos_Quantity-" + index.toString()} inputType={"text"} inputValue={position.Quantity} inputClassName={"d-none"} />
                    <Input inputID={"pos_Deduction-" + index.toString()} inputType={"text"} inputValue={position.Deduction} inputClassName={"d-none"} />
                    <Input inputID={"pos_PricePerUnit-" + index.toString()} inputType={"text"} inputValue={position.PricePerUnit} inputClassName={"d-none"} />
                    <Input inputID={"pos_BillingRecipient-" + index.toString()} inputType={"text"} inputValue={position.BillingRecipient} inputClassName={"d-none"} />
                    <Input inputID={"pos_ServID-" + index.toString()} inputType={"text"} inputValue={position.ServID} inputClassName={"d-none"} />
                    <Input inputID={"pos_Date-" + index.toString()} inputClassName={"input-field"} inputStyle={{ border: "none", padding: "1px" }} inputType={'date'} inputValue={changeDateFormat(position._Date)} />  
                </td>
                <td>
                    <CheckBox chkID={"pos_DateFixed-" + index.toString()} chkType={"checkbox"} chkIndicatorStyle={{position: "relative"}} chkValue={position.FixedDate} chkStyle={{marginBottom: "0px", paddingTop: "0px"}} />
                </td>
                <td>
                    <Input inputID={"pos_Quantity-" + index.toString()} inputStyle={{ border: "none", padding: "1px", width: "100%" }} inputType={'number'} inputValue={position.Quantity} />  
                </td>
                <td>
                    <select id={"pos_Unit-" + index.toString()} style={{ border: "none", width: "100%" }}>
                        <SelectOptions defValue={position.Unit} />
                    </select>
                </td>
            </tr>
        ));
      };

    return (
        <div className="table-responsive" style={{ maxHeight: "300px", overflow: "auto", margin: "auto" }}>
            <table className="table">
                <thead className="table-orderHeader bookingRecord" style={{ textAlign: "center", verticalAlign: "middle", zIndex: "99999" }}>
                    <tr>
                        <th style={{ width: "100px", backgroundColor: "var(--orderViewBackground)" }} key="Takeover">
                            <span>{ Translate("Takeover") }</span>
                        </th>
                        <th style={{ width: "220px", backgroundColor: "var(--orderViewBackground)" }} key="Name">
                            <span>{ Translate("Name") }</span>
                        </th>
                        <th className={'d-none'} key="Text1"></th>
                        <th className={'d-none'} key="Description"></th>
                        <th className={'d-none'} key="Execution"></th>
                        <th className={'d-none'} key="QuantityDef"></th>
                        <th className={'d-none'} key="Deduction"></th>
                        <th className={'d-none'} key="PricePerUnit"></th>
                        <th className={'d-none'} key="BillingRecipient"></th>
                        <th className={'d-none'} key="ServID"></th>
                        <th style={{ width: "90px", backgroundColor: "var(--orderViewBackground)" }} key="Date">
                            <span>{ Translate("Date") }</span>
                        </th>
                        <th style={{ width: "100px", backgroundColor: "var(--orderViewBackground)" }} key="DateFixed">
                            <span>{ Translate("Date fixed") }</span>
                        </th>
                        <th style={{ width: "70px", backgroundColor: "var(--orderViewBackground)" }} key="Quantity">
                            <span>{ Translate("Quantity") }</span>
                        </th>
                        <th style={{ width: "80px", backgroundColor: "var(--orderViewBackground)" }} key="Unit">
                            <span>{ Translate("Unit") }</span>
                        </th>
                    </tr>
                </thead>
                <tbody className="table-orderBody bookingRecord">
                    {RenderPositions()}
                </tbody>
            </table>
        </div>
       
        /* <div>
            <Table
                data={data.Positions}
                tableStyle={{ maxHeight: "350px" }}
                markCells={true}
                markRow={false}
                onDataChange={""}
            />
        </div> */
    );
}

//#endregion orderView Functions

//-------------------------------------------------------------------------------------------------------------------

//#region dynamicTable Functions

export function CreateDynTableData(jsonResp)
{
    if(typeof jsonResp === "string" && jsonResp !== "") 
    { 
        const respData = JSON.parse(jsonResp); 
        const headers = Array.from(
            new Set(respData.flatMap((item) => Object.keys(item)))
        );
        
        const data = {
            columns: headers, 
            rows: respData
        };
    
        return data;
    }

    return null;
}

//#endregion dynamicTable Functions

//-------------------------------------------------------------------------------------------------------------------